import { LlmInitializationInputSchema } from "@redotech/redo-model/agents/llm-initialization-input";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getInitializationInputsForAgent = {
  name: "getInitializationInputsForAgent" as const,
  input: z.object({
    agentName: z.string(),
    team: zExt.objectId().optional(),
    limit: z.number().optional(),
    // Cursor for infinite scroll - using createdAt + _id for uniqueness
    cursor: z.object({ createdAt: z.date(), _id: zExt.objectId() }).optional(),
    // Keep offset for backwards compatibility
    offset: z.number().optional(),
    startDate: z.date().optional(),
    endDate: z.date().optional(),
    excludeInitializationInputIds: z.array(zExt.objectId()).optional(),
  }),
  output: z.object({
    data: z.array(LlmInitializationInputSchema),
    totalCount: z.number(),
    // Next cursor for infinite scroll
    nextCursor: z
      .object({ createdAt: z.date(), _id: zExt.objectId() })
      .optional(),
    hasMore: z.boolean(),
  }),
};
